import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/google",
    meta: { title: "Google 数据" },
    redirect: "/google/overview",
    component: Layout,
    children: [
      {
        path: "/google/overview",
        meta: {
          title: "数据看板",
          icon: "icon-icon-test",
          parentPath: "/google",
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "overview",
        },
        component: () => import("@/views/google/index.vue"),
      },
      {
        path: "/google/data",
        meta: {
          title: "站点数据",
          icon: "icon-icon-test",
          parentPath: "/google",
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "site-data",
        },
        component: () => import("@/views/google/index.vue"),
      },
      {
        path: "/google/data/detail/:siteId",
        meta: {
          title: "站点详情",
          icon: "icon-icon-test",
          parentPath: "/google",
          prevPath: "/google/data",
          hidden: true,
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "site-detail",
        },
        component: () => import("@/views/google/index.vue"),
      },
      {
        path: "/google/bindings",
        meta: {
          title: "站点绑定",
          icon: "icon-icon-test",
          parentPath: "/google",
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "bindings",
        },
        component: () => import("@/views/google/index.vue"),
      },
      {
        path: "/google/accounts",
        meta: {
          title: "授权账号",
          icon: "icon-icon-test",
          parentPath: "/google",
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "accounts",
        },
        component: () => import("@/views/google/index.vue"),
      },
      {
        path: "/google/settings",
        meta: {
          title: "Google 设置",
          icon: "icon-icon-test",
          parentPath: "/google",
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "settings",
        },
        component: () => import("@/views/google/index.vue"),
      },
      {
        path: "/google/logs",
        meta: {
          title: "同步日志",
          icon: "icon-icon-test",
          parentPath: "/google",
          permissionKey: "google_data",
          permissionAction: "view",
          googleTab: "logs",
        },
        component: () => import("@/views/google/index.vue"),
      },
    ],
  },
];

export default routes;
